/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Show_OriginalInputs */

const en_recipe_show_original = /** @type {(inputs: Recipe_Show_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show original`)
};

const de_recipe_show_original = /** @type {(inputs: Recipe_Show_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original anzeigen`)
};

/**
* | output |
* | --- |
* | "Show original" |
*
* @param {Recipe_Show_OriginalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_show_original = /** @type {((inputs?: Recipe_Show_OriginalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Show_OriginalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_show_original(inputs)
	return en_recipe_show_original(inputs)
});